import React from "react";

interface CheckboxProps {
  label: string | undefined;
  checked?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  disabled?: boolean;
}

export default function Checkbox({
  label,
  checked = false,
  onChange,
  disabled = false,
}: CheckboxProps) {
  return (
    <div className="flex items-center">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={`w-5 h-5 accent-electrum border-2 border-electrum ${
          disabled ? "opacity-50 cursor-not-allowed" : ""
        }`}
      />
      <label
        className={`ml-2 text-[#1D1D1D] ${disabled ? "text-gray-500" : ""}`}
      >
        {label}
      </label>
    </div>
  );
}
